import { __values } from "tslib";
import { debugLog } from '@graphql-tools/utils';
import { Kind } from 'graphql';
/**
 * @internal
 */
export var filterKind = function (content, filterKinds) {
    var e_1, _a;
    if (content && content.definitions && content.definitions.length && filterKinds && filterKinds.length > 0) {
        var invalidDefinitions = [];
        var validDefinitions = [];
        try {
            for (var _b = __values(content.definitions), _c = _b.next(); !_c.done; _c = _b.next()) {
                var definitionNode = _c.value;
                if (filterKinds.includes(definitionNode.kind)) {
                    invalidDefinitions.push(definitionNode);
                }
                else {
                    validDefinitions.push(definitionNode);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (invalidDefinitions.length > 0) {
            invalidDefinitions.forEach(function (d) {
                debugLog("Filtered document of kind " + d.kind + " due to filter policy (" + filterKinds.join(', ') + ")");
            });
        }
        return {
            kind: Kind.DOCUMENT,
            definitions: validDefinitions,
        };
    }
    return content;
};
//# sourceMappingURL=filter-document-kind.js.map